export default __webpack_public_path__ + "static/media/default_news_image.ba368200.jpg";